import { ReactElement, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import style from './Map.module.scss';

type Props = {
  lat: number;
  lng: number;
}

export default function LocationDetailMap(props: Props): ReactElement {
  const mapRef = useRef(null);

  const apiIsLoaded = (map, maps) => {
    const circle = new maps.Circle({
      map: map,
      radius: 500,
      center: {
        lat: props.lat,
        lng: props.lng,
      },
      strokeColor: '#F5885E',
      fillColor: '#F5885E',
      fillOpacity: .3,
    });
  };

  const createMapOptions = (maps) => {
    // next props are exposed at maps
    // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
    // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition", "SymbolPath", "ZoomControlStyle",
    // "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem", "DistanceMatrixStatus",
    // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType", "GeocoderStatus", "KmlLayerStatus",
    // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference", "TravelMode", "UnitSystem"
    return {
      fullscreenControl: false,
      // zoomControl: false,
      zoomControlOptions: {
        position: maps.ControlPosition.TOP_RIGHT,
      },
      maxZoom: 16,
      minZoom: 10,
    };
  };

  return (
    <div className={ style.map }>
      <GoogleMapReact
        bootstrapURLKeys={ { key: 'AIzaSyAjb8GLflKqFOFq6VwDe-1xZ_re0EV8n9w' } }
        center={ { lat: props.lat, lng: props.lng } }
        defaultZoom={ 14 }
        options={ createMapOptions }
        ref={ mapRef }
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={ ({ map, maps }) => apiIsLoaded(map, maps) }
      />
      <div className={ style.notification }>The exact location will be provided after booking</div>
    </div>
  );
}
